import "./dark-card.css";
interface DarkCardProps {
  title: string;
  icon: React.ReactNode;
  description: string;
}
function DarkCardComponent({ title, icon, description }: DarkCardProps) {
  return (
    <div data-aos="zoom-in">
      <div className="dark-card-container">
        <div className="dark-card-icon">{icon}</div>
        <div className="dark-card-title">{title}</div>
        <div className="dark-card-description">{description}</div>
      </div>
    </div>
  );
}

export default DarkCardComponent;
